type MaybeHasEmail = { email?: string | null | undefined };

// Sort records that might have emails. All records with emails on top, sorted
// alphabetically by email, followed by all records without emails, sorted
// arbitrarily.
export const compareByEmail = (a: MaybeHasEmail, b: MaybeHasEmail): number => {
  if (a.email === b.email) {
    return 0;
  }
  if (!a.email) {
    return 1;
  }
  if (!b.email) {
    return -1;
  }
  return a.email.localeCompare(b.email);
};
